const ApiConfig = {
    baseUrl: "https://tigrispay.com/prod/api",
    
};
export default ApiConfig;
